import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageLayoutComponent } from './page-layout.component';

const routes: Routes = [
    {
        path: '',
        component: PageLayoutComponent,
        children: [
            {
                path: 'contact-us',
                loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule)
            },
            {
                path: 'privacy-policy',
                loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
            },
            {
                path: 'terms-and-conditions',
                loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
            },
            {
                path: 'copyright',
                loadChildren: () => import('./copyright/copyright.module').then(m => m.CopyrightModule)
            },
            {
                path: 'about-us',
                loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule)
            },
            {
                path: 'download-tender-mobile-app',
                loadChildren: () => import('./download-tender-mobile-app/download-tender-mobile-app.module').then(m => m.LandingPageModule)
            },
            
            {
                path: 'user-profile',
                loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule)
            },
        ]
    },

    // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class PagesRoutingModule { }